import type { FormSchemaVersion } from '../../services/api/types.gen';

/**
 * Choose the schema version to auto-select for the current form type.
 * URL-restored selection wins on first load; otherwise the top version.
 * EMR-191 item 11.
 */
export function pickInitialVersion(
  versions: FormSchemaVersion[],
  urlState: { schemaName?: string | null; schemaVersion?: string | null }
): FormSchemaVersion | null {
  if (versions.length === 0) return null;
  if (urlState.schemaName) {
    const match = versions.find(
      v =>
        v.name === urlState.schemaName &&
        `${v.version ?? ''}` === `${urlState.schemaVersion ?? ''}`
    );
    if (match) return match;
  }
  return versions[0];
}
